import { useAsyncError } from '@common/hooks/useAsyncError';
import { useSession } from 'src/apps/invest/common/hooks/useSession';

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PAGES } from '../constants';
import { useCheckoutSFRViewModel } from '../models/CheckoutSFRViewModel';
import { CheckoutSFRAmountPage } from '../views/pages/CheckoutSFRAmountPage';
import { CheckoutSFRConfirmationPage } from '../views/pages/CheckoutSFRConfirmationPage';
import { CheckoutSFRCongratsPage } from '../views/pages/CheckoutSFRCongratsPage';
import { CheckoutSFRErrorPage } from '../views/pages/CheckoutSFRErrorPage';
import { CheckoutSFRLoadingPage } from '../views/pages/CheckoutSFRLoadingPage';
import { CheckoutSFRPricingPlanPage } from '../views/pages/CheckoutSFRPricingPlanPage';
import { usePermissions } from 'src/apps/invest/common/hooks/usePermissions';
import { Permission } from '@common/permissions';
import { PageNotFound } from '@common/pages/PageNotFound';

const sessionRedirect = window.location.pathname;
const permissions: Permission[] = ['ACCREDITED_INVESTOR', 'UNACCREDITED_INVESTOR'];

export const CheckoutSFRController: React.FC = () => {
  const { checkAuthenticated } = useSession();
  const { checkPermissions } = usePermissions();

  const viewModel = useCheckoutSFRViewModel();
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const throwError = useAsyncError();

  async function init() {
    if (!(await checkAuthenticated(sessionRedirect))) return;
    if (!(await checkPermissions(permissions))) return;

    await viewModel.initController({ propertyId: id });
    setIsLoading(false);
  }

  useEffect(() => {
    init().catch((err) => throwError(err));
  }, []);

  if (isLoading) return <CheckoutSFRLoadingPage />;

  switch (viewModel.page) {
    case PAGES.amount:
      return <CheckoutSFRAmountPage />;
    case PAGES.confirmation:
      return <CheckoutSFRConfirmationPage />;
    case PAGES.congrats:
      return <CheckoutSFRCongratsPage />;
    case PAGES.error:
      return <CheckoutSFRErrorPage />;
    case PAGES.pricingPlan:
      return <CheckoutSFRPricingPlanPage />;
    default:
      return <PageNotFound />;
  }
};
